import {getData,getAll} from '@/api/family'

const getDefaultState = () => {
    return {
        family:null
    }
}
const state = getDefaultState()
const mutations = {
    SET_DATA_ALL: (state, data) => {
        state.family = data
    },
}

const actions = {
    getAll({commit}) {
        return new Promise((resolve, reject) => {
            getAll().then((rs) => {
                commit('SET_DATA_ALL', rs)
                resolve(rs)
            }).catch(error => {
                reject(error)
            })
        })

    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
